import request from '@/utilities/request'

// Common service API
export function getRefCodes () {
  return request({
    url: '/refCodes',
    method: 'get'
  })
}